import React from "react";
import StarRatings from "components/StarRatings/StarRatings";
import TextArea from "components/TextArea/TextArea";
import "components/FeedbackForm/FeedbackForm.css";

//Loads feedback components.
function FeedbackForm({ userRatings, onRatingChange, onTextChange }) {
  const componentTexts = window.appTexts.components.feedback_form;

  return (
    <div className="feedback-form">
      <h4 className="main-head">{componentTexts.page_title}</h4>
      <div className="feedback-form__star-rating">
        <StarRatings userRatings={userRatings} onClick={onRatingChange} />
      </div>
      <div className="feedback-form__text-area">
        <TextArea
          placeholder={componentTexts.textarea_placeholder}
          onChange={onTextChange}
          className="inner-shadow"
        />
      </div>
    </div>
  );
}

export default FeedbackForm;
